import React, { useEffect, useRef, useState } from "react";
import { useCmsSection } from "@/hooks/useCmsContent";
import Editable from "@/components/cms/Editable";
import styles from './hero.module.css';

const HERO_FALLBACKS = {
    title: 'Kwik Fill Giveaway!',
    body: '',
    cta_text: 'Learn More',
    cta_link: '/win',
    video_url: 'https://operation-give-thanks.s3.amazonaws.com/website/default_video.mp4',
};

export default function Hero() {
    const { fields, refetch } = useCmsSection('home', 'hero', HERO_FALLBACKS);

    const videoRef = useRef<HTMLVideoElement>(null);
    const [playbackRate] = useState(0.75);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = playbackRate;
        }
    }, [playbackRate]);

    return (
        <div className={styles.container}>
            <div className={styles.container_inner}>
                <div className={styles.video_wrapper}>
                    <video ref={videoRef} className={styles.video} width="320" height="240" autoPlay loop muted>
                        <source src={fields.video_url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className={styles.content_gradient_overlay}></div>

                <div className={styles.content_container} style={{ textAlign: 'center' }}>
                    <Editable page="home" section="hero" field="title" value={fields.title}>
                        <h1 className={styles.title}>{fields.title}</h1>
                    </Editable>
                    <Editable page="home" section="hero" field="body" value={fields.body}>
                        <div className={styles.body}>{fields.body}</div>
                    </Editable>
                    <Editable page="home" section="hero" field="cta_text" value={fields.cta_text}>
                        <div onClick={() => { window.location.href = fields.cta_link; }} className={styles.button}>{fields.cta_text}</div>
                    </Editable>
                </div>
            </div>
        </div>
    );
}
